import { appURLs } from '@utils/AppUtil';

export const POST_LOGIN_REDIRECT_URL_KEY = 'redirectUrl';

export type PostLoginLocation = {
  pathname: string;
  search?: string;
};

export const getLocationPathWithSearch = (location: PostLoginLocation): string =>
  `${location.pathname}${location.search || ''}`;

export const isActionCenterPath = (pathname: string): boolean =>
  pathname.includes(`/${appURLs.actionCenterPartialURL}`);

export const isCaseOrCustomerSubmissionPath = (pathname: string): boolean =>
  pathname.includes('/products/cases') || pathname.includes('products/customer-submission');

/**
 * Persist deep-link URLs through staff SSO so post-login restore can return
 * the user to the same path + query (e.g. Action Center phone_number).
 *
 * - Action Center: always overwrite (live Teams pop wins over a stale bookmark)
 * - Cases / customer submissions: first-wins (existing behavior)
 */
export const persistPostLoginRedirectUrl = (location: PostLoginLocation): void => {
  const { pathname } = location;
  const fullUrl = getLocationPathWithSearch(location);
  const existing = sessionStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY);

  if (isActionCenterPath(pathname)) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, fullUrl);

    return;
  }

  if (isCaseOrCustomerSubmissionPath(pathname) && existing === null) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, fullUrl);
  }
};

export const consumePostLoginRedirectUrl = (): string | null => {
  const url = sessionStorage.getItem(POST_LOGIN_REDIRECT_URL_KEY);
  if (url) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_URL_KEY);
  }

  return url;
};
